import OrderCargoOrderDriverSimulationRequest from "../../../../api/raily/order/cargo-order/driver-simulation/order-cargo-order-driver-simulation.request";
import OrderCargoOrderDriverSimulationParams from "./order-cargo-order-driver-simulation.params";

const create = (
  params: OrderCargoOrderDriverSimulationParams,
): OrderCargoOrderDriverSimulationRequest => {
  return {
    driverUuid: params.driverUuid,
    orderUuid: params.orderUuid,
  };
};

const orderCargoOrderDriverSimulationParamsFactory = {
  create,
};

export default orderCargoOrderDriverSimulationParamsFactory;
